import React from 'react';
import { translate } from '@utils/i18n';
import { BarList } from '@ui/molecules/BarList';
import { DashboardCard } from '@ui/molecules/DashboardCard';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
function TopIssueCategoriesChart({ data, isLoading, className }) {
    const items = data.map((category) => ({
        label: translate(`bottom.issue_types.${category.name}`, { namespace }),
        value: category.count
    }));
    return (React.createElement(DashboardCard, { title: translate('bottom.top_issue_categories', { namespace }), subtitle: translate('bottom.top_issue_subtitle', { namespace }), isLoading: isLoading, className: className }, data.length === 0 ? React.createElement("p", null, translate('chart.no_data', { namespace })) : React.createElement(BarList, { items: items })));
}
export default TopIssueCategoriesChart;
